export default "__VITE_ASSET__BDvTq6Y$__"